<template>
  <tr class="_middle">
    <td>
      <div class="account-tab-item__date">
        {{ item.created_at | formatDate }}
      </div>
    </td>

    <td>
      <div class="account-tab-item__operation">
        <div v-if="item.withdraw_method"
             class="account-tab-item__operation-el">
          <BaseSvg :name="item.withdraw_method.icon"
                   class="account-tab-item__operation-ico"/>
          <span>{{ item.withdraw_method.name }}</span>
        </div>
      </div>
    </td>

    <td>
      <div class="account-tab-item__status">
        <div class="status _grey" v-if="item.status === STATUS_RECEIVED_TO_WORK">
          {{ $tAccount('Accepted for work') }}
        </div>
        <div class="status _orange" v-if="item.status === STATUS_IN_PROCESS">
          {{ $tAccount('Processed') }}
        </div>
        <div class="status _green" v-if="item.status === STATUS_PAID_OUT">
          {{ $tAccount('Paid out') }}
        </div>
      </div>
    </td>

    <td>
      <div class="account-tab-item__date">
        {{ item.end_date | formatDate }}
      </div>
    </td>

    <td class="_text-right">
      <div class="account-tab-item__sum-wrap">
        <button type="button" class="account-tab-item__repeat base-btn base-btn--small base-btn--outline-dark">
          <BaseSvg name="ico-update"/>
        </button>
        <div class="account-tab-item__sum">
          - {{ item.sum | formatCurrency }} <span>JBN</span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  const STATUS_RECEIVED_TO_WORK = 1
  const STATUS_IN_PROCESS = 2
  const STATUS_PAID_OUT = 3

  export default {
    name: 'AccountTabItemWithdrawRow',
    props: {
      item: Object
    },
    data() {
      return {
        STATUS_RECEIVED_TO_WORK,
        STATUS_IN_PROCESS,
        STATUS_PAID_OUT,
      }
    }
  }
</script>

<style>

</style>
